import * as Alerts from './Alerts/AlertsState';
import * as Assets from './Assets/AssetsState';
import * as AssetStates from './Devices/AssetStatesState';
import * as UserSession from './UserSession/UserSessionState';
import * as UserSettings from './UserSettings/UserSettingsState';
import * as ReferenceWeights from './ReferenceWeights/ReferenceWeightsState';
import * as Reports from './Reports/ReportsState';
import * as Versions from './Versions/VersionsState';
import * as Tickets from './Tickets/TicketsState';
import * as NBC from './NBC/NBCState';
import * as ConfigSettings from './Config/Settings/ConfigSettingsState';
import * as Maintenance from './Maintenance/MaintenanceState';
import * as Logs from './LogsUpload/LogsState';
import * as Commands from './Commands/CommandsState';
import * as Notifications from './Notifications/NotificationsState';
import * as Products from './ProductsManagement/ProductsState';
import { unloadedState as alertsUnloadedState } from '../store/Alerts/AlertsState';
import { unloadedState as assetsUnloadedState } from '../store/Assets/AssetsState';
import { unloadedState as assetStatusesStateUnloadedState } from './Devices/AssetStatesState';
import { unloadedState as userSessionUnloadedState } from '../store/UserSession/UserSessionState';
import { unloadedState as userSettingsUnloadedState } from '../store/UserSettings/UserSettingsState';
import { unloadedState as referenceWeightsUnloadedState } from '../store/ReferenceWeights/ReferenceWeightsState';
import { unloadedState as reportsUnloadedState } from '../store/Reports/ReportsState';
import { unloadedState as versionsUnloadedState } from './Versions/VersionsState';
import { unloadedState as ticketsUnloadedState } from '../store/Tickets/TicketsState';
import { unloadedState as configSettingsUnloadedState } from '../store/Config/Settings/ConfigSettingsState';
import { unloadedState as nbcUnloadedState } from '../store/NBC/NBCState';
import { unloadedState as maintenanceUnloadedState } from '../store/Maintenance/MaintenanceState';
import { unloadedState as logsUnloadedState } from '../store/LogsUpload/LogsState';
import { unloadedState as CommandssUnloadedState } from '../store/Commands/CommandsState';
import { unloadedState as notificationsUnloadedState } from '../store/Notifications/NotificationsState';
import * as AccessControl from './AccessControl/AccessControlState';
import { unloadedState as accessControlUnloadedState } from '../store/AccessControl/AccessControlState';
import { unloadedState as artifactsUnloadedState } from './ProductsManagement/ProductsState';

// The top-level state object
export interface ApplicationState {
  alertsReducer: Alerts.AlertsState;
  assetsReducer: Assets.AssetsState;
  assetStatusesReducer: AssetStates.AssetStatusesState;
  userSessionReducer: UserSession.UserSessionState;
  userSettingsReducer: UserSettings.UserSettingsState;
  referenceWeightsReducer: ReferenceWeights.ReferenceWeightsState;
  reportsReducer: Reports.ReportsState;
  versionsReducer: Versions.VersionsState;
  ticketsReducer: Tickets.TicketsState;
  configSettingsReducer: ConfigSettings.ConfigSettingsState;
  nbcReducer: NBC.NBCState;
  maintenanceReducer: Maintenance.MaintenanceState;
  logs: Logs.LogsState;
  commands: Commands.CommandsState;
  notificationsReducer: Notifications.NotificationsState;
  accessControlReducer: AccessControl.AccessControlState;
  productsReducer: Products.ProductsState;
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
  alertsReducer: Alerts.reducer,
  assetsReducer: Assets.reducer,
  assetStatusesReducer: AssetStates.reducer,
  userSessionReducer: UserSession.reducer,
  userSettingsReducer: UserSettings.reducer,
  referenceWeightsReducer: ReferenceWeights.reducer,
  reportsReducer: Reports.reducer,
  versionsReducer: Versions.reducer,
  ticketsReducer: Tickets.reducer,
  configSettingsReducer: ConfigSettings.reducer,
  nbcReducer: NBC.reducer,
  maintenanceReducer: Maintenance.reducer,
  logs: Logs.reducer,
  commands: Commands.reducer,
  notificationsReducer: Notifications.reducer,
  accessControlReducer: AccessControl.reducer,
  productsReducer: Products.reducer,
};

export const initialAppState: ApplicationState = {
  alertsReducer: alertsUnloadedState,
  assetsReducer: assetsUnloadedState,
  assetStatusesReducer: assetStatusesStateUnloadedState,
  userSessionReducer: userSessionUnloadedState,
  userSettingsReducer: userSettingsUnloadedState,
  referenceWeightsReducer: referenceWeightsUnloadedState,
  reportsReducer: reportsUnloadedState,
  versionsReducer: versionsUnloadedState,
  ticketsReducer: ticketsUnloadedState,
  configSettingsReducer: configSettingsUnloadedState,
  nbcReducer: nbcUnloadedState,
  maintenanceReducer: maintenanceUnloadedState,
  logs: logsUnloadedState,
  commands: CommandssUnloadedState,
  notificationsReducer: notificationsUnloadedState,
  accessControlReducer: accessControlUnloadedState,
  productsReducer: artifactsUnloadedState,
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface AppThunkAction<TAction> {
  (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}
